'use strict';

var processInclude = require('../base/util');

module.exports = {
    doNotSave: function () {
        $(document).on('click', 'form.optins button[value="do-not-save"]', function () {
            $(this).closest('form.optins').find(':checkbox').prop('checked', false);
        });
    },
    submit: function () {
        $(document).on('submit', 'form.optins', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();

            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.templateAndForm) {
                        $('#login-flow-holder').html(data.templateAndForm.template);
                        processInclude(require('../components/formValidation'));
                        processInclude(require('../components/clientSideValidation'));
                        const notification = require('../util/notification');
                        notification.createNotification(data.popupMessage, 'success');
                    } else {
                        var popup = require('../components/popup');
                        popup.setPopupCookie(data.popupMessage);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $form.spinner().stop();

                        $(this).delay(5000).queue(function () {
                            $('.alert-danger').remove();
                        });
                    }
                }
            });

            return false;
        });
    }
};
